import React from 'react'
import XIcon from '@mui/icons-material/X'
import YouTubeIcon from '@mui/icons-material/YouTube'
import FacebookIcon from '@mui/icons-material/Facebook'
import InstagramIcon from '@mui/icons-material/Instagram'
import MusicNoteIcon from '@mui/icons-material/MusicNote'
import PublicIcon from '@mui/icons-material/Public'
import type { SocialPlatform } from '../../../utils/socialAccounts'

/** The platform's mark, or a globe for one this build does not know. */
const PlatformIcon: React.FC<{ platform: SocialPlatform | string; fontSize?: 'small' | 'medium' }> = ({ platform, fontSize = 'small' }) => {
  switch (platform) {
    case 'twitter': return <XIcon fontSize={fontSize} />
    case 'youtube': return <YouTubeIcon fontSize={fontSize} />
    case 'facebook': return <FacebookIcon fontSize={fontSize} />
    case 'instagram': return <InstagramIcon fontSize={fontSize} />
    case 'tiktok': return <MusicNoteIcon fontSize={fontSize} />
    default: return <PublicIcon fontSize={fontSize} />
  }
}

export default PlatformIcon
